const authSessionMapping = ({sessionId, expiresAt}) => ({sessionId, expiresAt: Date.parse(expiresAt)});

export default {
    authSessionMapping,
};
